import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import styles from '@/components/Common/FormItem/FormItem.styles';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import { FormControlLabel, Grid, Stack, Switch } from '@mui/material';
import { usePaymentDataViewController } from './PaymentDataViewController';

export function PaymentData() {
  const { uiState, actions } = usePaymentDataViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Métodos de Pago'} />
      <BasicContainer
        content={
          <Grid container spacing={'16px'} p={'16px'}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.enableAllPaymentMethods}
                    onChange={(e) =>
                      actions.onChangeEnableAllPaymentMethods(e.target.checked)
                    }
                  />
                }
                sx={styles.label}
                label="Habilitar todos los medios de pago"
              />
            </Grid>
          </Grid>
        }
      />
    </Stack>
  );
}
